import { ASE_INTERNAL_RESET_REDIRECT, ASE_INTERNAL_SET_LOCK_TICKET } from '../../actions/ase/actionAseInternalLockTicket';
import {
    ASE_INTERNAL_GET_SG_INFO_RESET,
    ASE_INTERNAL_TICKET_CREATE,
    ASE_INTERNAL_TICKET_RESET,
    ASE_INTERNAL_TICKET_UPDATE
} from '../../actions/ase/actionAseInternalTicket';
import { ASE_INTERNAL_CLEAR_RELATED_TECHNICAL_BULLETINS } from '../../actions/ase/actionAseInternalTechnicalBulletinTicket';
import {
    ASE_INTERNAL_CHECK_TECHNICAL_BULLETIN_NUMBER_SEND,
    ASE_INTERNAL_GET_SG_INFO,
    ASE_INTERNAL_GET_TICKET,
    ASE_INTERNAL_TICKET_ATTACHMENTS_SAVED,
    ASE_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR,
    ASE_INTERNAL_TICKET_CREATED,
    ASE_INTERNAL_TICKET_LOCKED,
    ASE_INTERNAL_TICKET_LOCKED_ERROR,
    ASE_INTERNAL_TICKET_LOCKED_FATAL,
    ASE_INTERNAL_TICKET_SEND,
    ASE_INTERNAL_TICKET_SEND_ERROR,
    ASE_INTERNAL_TICKET_SG_INFO_ERROR,
    ASE_INTERNAL_TICKET_SG_INFO_SEND,
    ASE_INTERNAL_TICKET_UPDATED
} from '../../constants/websocketCommands';

export const aseInternalTicket = (state = {
    correlationId: null,
    correlationIdSgInfo: null,
    isTicketLoading: false,
    isTicketCreating: false,
    created: false,
    ticket: {},
    vehicleDetail: {},
    partDetail: {},
    problemDescription: {},
    logs: [],
    messages: [],
    attachments: [],
    newAttachments: [],
    ticketReference: {},
    canTakeBack: false,
    relatedTechnicalBulletins: []
}, action) => {
    switch (action.type) {
        case ASE_INTERNAL_TICKET_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                correlationIdSgInfo: null,
                isTicketLoading: false,
                isTicketCreating: false,
                created: false,
                ticket: {},
                vehicleDetail: {},
                problemDescription: {},
                logs: [],
                attachments: [],
                newAttachments: [],
                ticketReference: {},
                canTakeBack: false,
            });
        }
        case ASE_INTERNAL_TICKET_UPDATE:
        case ASE_INTERNAL_TICKET_CREATE: {
            const {newAttachments} = action.payload;
            return Object.assign({}, state, {
                newAttachments,
                isTicketCreating: true,
                created: false,
                isTicketLoading: true,
                vehicleDetail: {},
                problemDescription: {},
                messages: [],
                logs: [],
                attachments: [],
                ticketReference: {},
            });
        }
        //command accepted
        case ASE_INTERNAL_TICKET_CREATED:
        case ASE_INTERNAL_TICKET_UPDATED:
        case ASE_INTERNAL_GET_TICKET: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketCreating: false,
                created: true,
                isTicketLoading: true,
                correlationId
            });
        }

        case ASE_INTERNAL_TICKET_SEND: {
            const {ticket, correlationId, vehicleDetail, problemDescription, logs, attachments, error, messages, solutionGroupInfo, canTakeBack, documentationUpdate, ticketReference} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            if (error) {
                return Object.assign({}, state, {isTicketLoading: false, correlationId});
            }
            return Object.assign({}, state, {
                isTicketLoading: false,
                correlationId,
                ticket,
                vehicleDetail,
                problemDescription,
                logs,
                attachments,
                messages,
                solutionGroupInfo,
                canTakeBack,
                documentationUpdate,
                ticketReference,
            });
        }

        case ASE_INTERNAL_TICKET_SEND_ERROR: {
            const { correlationId } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }

            return Object.assign({}, state, {
                problemDescription: {}
            });
        }

        case ASE_INTERNAL_GET_SG_INFO: {
            return Object.assign({}, state, {
                solutionGroupInfo: {}
            });
        }
        case ASE_INTERNAL_GET_SG_INFO_RESET: {
            return Object.assign({}, state, {
                solutionGroupInfo: {}
            });
        }
        case ASE_INTERNAL_TICKET_SG_INFO_SEND: {
            const {correlationId, solutionGroupInfo} = action.payload;

            if (correlationId < state.correlationIdSgInfo) {
                return state;
            }
            return Object.assign({}, state, {
                solutionGroupInfo,
                correlationIdSgInfo: correlationId
            });
        }
        case ASE_INTERNAL_TICKET_SG_INFO_ERROR: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationIdSgInfo) {
                return state;
            }
            return Object.assign({}, state, {
                solutionGroupInfo: {},
                correlationIdSgInfo: correlationId
            });
        }
        //att done + error
        // case TECH_DOC_INTERNAL_ATTACHMENTS_UPLOADING_ERROR:
        case ASE_INTERNAL_TICKET_ATTACHMENTS_SAVED_ERROR: {
            return Object.assign({}, state, {
                newAttachments: [],
            });
        }
        case ASE_INTERNAL_TICKET_ATTACHMENTS_SAVED: {
            const {correlationId} = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isTicketLoading: true,
                correlationId,
                newAttachments: [],
            });
        }
        case ASE_INTERNAL_CHECK_TECHNICAL_BULLETIN_NUMBER_SEND: {
            const {correlationId, tickets} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                relatedTechnicalBulletins: tickets
            });
        }
        case ASE_INTERNAL_CLEAR_RELATED_TECHNICAL_BULLETINS: {
            return Object.assign({}, state, {
                relatedTechnicalBulletins: [],
            });
        }
        default:
            return state;
    }
};

export const aseLockInternalTicketCheck = (state = {
    correlationId: null,
    isTicketLocking: false,
    redirect: false,
}, action) => {
    switch (action.type) {
        case ASE_INTERNAL_TICKET_LOCKED_ERROR:
        case ASE_INTERNAL_TICKET_LOCKED_FATAL: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId,
                isTicketLocking: false,
                redirect: true,
            });
        }
        case ASE_INTERNAL_RESET_REDIRECT: {
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case ASE_INTERNAL_TICKET_LOCKED: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                correlationId: null,
                isTicketLocking: false,
                redirect: false,
            });
        }
        case ASE_INTERNAL_SET_LOCK_TICKET: {
            const {uuid} = action.payload;
            return Object.assign({}, state, {
                isTicketLocking: true,
                redirect: false,
                uuid,
            });
        }
        default:
            return state;
    }
};
